export function intersection<T>(
  a: ReadonlySet<T>,
  b: ReadonlySet<T>
): ReadonlySet<T> {
  return new Set([...a].filter((element) => b.has(element)));
}

export function difference<T>(
  a: ReadonlySet<T>,
  b: ReadonlySet<T>
): ReadonlySet<T> {
  return new Set([...a].filter((element) => !b.has(element)));
}
